import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';

const Expenses = () => {
    const [OfferId, setOfferId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [rows, setRows] = useState([]);

    const { apiUrl, apiHeadersJson, store_id } = useContext(ConfigContext);
    const headers = apiHeadersJson;
    const toast = useRef(null);

    const HandleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const body = {
            store_id: store_id,
            offer_start_time: startTime,
            offer_end_time: endTime,
            offer_id: OfferId,
        };

        try {
            const response = await axios.post(`${apiUrl}/Masters/CreateOffer`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    };

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetOfferList`, { params: { keyword, store_id }, headers });
            const { success, data, message } = response.data;

            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const handleResetForm = () => {
        setOfferId(null);
        setStartTime('');
        setEndTime('');
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Offer?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteBrand(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteBrand = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Masters/DeleteOffer`, { params: { offer_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const GetInfo = async (id) => {
        try {
            const response = await axios.get(`${apiUrl}/Masters/GetOfferInfo`, { params: { offer_id: id }, headers });
            const { success, data, message } = response.data;
            if (success) {
                const offer = data[0];
                setStartTime(offer.offer_start_time);
                setEndTime(offer.offer_end_time);
                setOfferId(offer.offer_id);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };


    useEffect(() => {
        GetList();
    }, [store_id]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            GetList();
        }, 500);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    const ActionBody = (data) => {
        return (
            <>
                <Button icon="pi pi-pencil" outlined onClick={() => GetInfo(data.offer_id)} />
                <Button outlined className='ms-3' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.offer_id)} />
            </>
        );
    };

    return (
        <>
            <div className="container-fluid">
                <Toast ref={toast} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <div className="main-heading">
                        <h6>Offer</h6>
                    </div>
                    <div className="main-heading-right">
                        <h6>Masters/Offer</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mt-4">
                        <div className="card">
                            <h4 className="bg-dark text-white rounded-top p-3">Offer</h4>
                            <form className='p-3' onSubmit={HandleSubmit}>
                                <div className="row">
                                    <div className="mt-0">
                                        <label className="form-label">Start Time</label>
                                        <input
                                            type="time"
                                            value={startTime}
                                            className="form-control"
                                            onChange={(e) => setStartTime(e.target.value)}
                                            required={true}
                                        />
                                    </div>
                                    <div className="my-3">
                                        <label className="form-label">End Time</label>
                                        <input
                                            type="time"
                                            value={endTime}
                                            className="form-control"
                                            onChange={(e) => setEndTime(e.target.value)}
                                            required={true}
                                        />
                                    </div>
                                </div>
                                {!OfferId && <Button
                                    type="submit"
                                    label={loading ? "Loading..." : "Submit"}
                                    className="btn btn-success mt-3"
                                    disabled={loading || !startTime || !endTime}
                                />}
                                {OfferId &&
                                    <div>
                                        <Button
                                            type="submit"
                                            label={loading ? "Loading..." : "Update"}
                                            className="btn btn-success mt-3"
                                            disabled={loading || !startTime || !endTime}
                                        />
                                        <Button
                                            type="button"
                                            onClick={handleResetForm}
                                            label={loading ? "Loading..." : "Reset"}
                                            className="btn btn-light mt-3 float-end"
                                            disabled={loading}
                                        />
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                    <div className="col-md-8 mt-4">
                        <div className="card">
                            <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                                <h4 className="text-white">Offer List</h4>
                            </div>
                            {dataTableLoading ? (
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                    <Skeleton shape='rectangle' width="100%" height="40px" className="mb-1" />
                                ))
                            ) : (
                                <DataTable value={rows} paginator rows={10} rowsPerPageOptions={[10, 20, 30]}>
                                    <Column field='store_name' header='Store Name' />
                                    <Column field='offer_start_time' header='Start Time' />
                                    <Column field='offer_end_time' header='End Time' />
                                    <Column body={ActionBody} header='Action' />
                                </DataTable>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Expenses;
